import React, { useEffect, lazy } from 'react';
import { Link } from 'react-router-dom';
import { CharReveal, Reveal, FadeUp, Kicker } from '../components/ui';
import { Odometer } from '../components/Odometer';
import { Footer } from '../components/Footer';
const STUDIO_IMG = 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2000&q=80';
const STATS = [{
  value: '128',
  suffix: '+',
  label: 'Projects shipped'
}, {
  value: '14',
  suffix: '',
  label: 'Client countries'
}, {
  value: '09',
  suffix: '',
  label: 'Years running'
}, {
  value: '87',
  suffix: '%',
  label: 'Clients who return'
}];
const PRINCIPLES = [{
  n: '.01',
  title: 'Say one thing',
  desc: 'A brand that says everything says nothing. We find the single idea worth defending and we build the whole system around it.'
}, {
  n: '.02',
  title: 'Argue early',
  desc: 'We push back in the room, not after launch. The best work comes from honest tension, not polite agreement.'
}, {
  n: '.03',
  title: 'Ship the real thing',
  desc: 'No dead-end decks. Everything we design is built to survive real use, real traffic and real deadlines.'
}, {
  n: '.04',
  title: 'Stay after launch',
  desc: 'Launch is the start line. We measure, we iterate, and we stay close until the numbers move.'
}];
const TEAM = [{
  name: 'Chidi Okafor',
  role: 'Creative Director',
  img: 'https://images.unsplash.com/photo-1531384441138-2736e62e0919?auto=format&fit=crop&w=500&q=80'
}, {
  name: 'Amaka Eze',
  role: 'Head of Strategy',
  img: 'https://cdn.magicpatterns.com/uploads/vuEf6zJZ7ivDFmhojaXQpQ/333333.png'
}, {
  name: 'Tunde Balogun',
  role: 'Design Lead',
  img: 'https://cdn.magicpatterns.com/uploads/oxX5bb5dPRnjqivEGd3qeP/222222.png'
}, {
  name: 'Ngozi Umeh',
  role: 'Motion Director',
  img: 'https://cdn.magicpatterns.com/uploads/ppT3P7e1BJjmaHgrkB3aVw/11111.png'
}];
export function About() {
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, []);
  return <main data-id="element-245">
      {/* Split hero — image + brand statement */}
      <section className="relative min-h-screen w-full overflow-hidden" style={{
      background: 'var(--ink)'
    }} data-id="element-246">
        <div className="absolute inset-0 grid grid-cols-1 md:grid-cols-2" aria-hidden="true" data-id="element-247">
          <span className="hidden md:block" style={{
          background: 'var(--ink-2)'
        }} data-id="element-248" />
          <span className="relative overflow-hidden" data-id="element-249">
            <img src={STUDIO_IMG} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-250" />
            <span className="absolute inset-0" style={{
            background: 'var(--danfo)',
            mixBlendMode: 'multiply',
            opacity: 0.82
          }} data-id="element-251" />
            <span className="absolute inset-0" style={{
            background: 'linear-gradient(180deg, rgba(17,16,19,0.55) 0%, rgba(17,16,19,0.2) 45%, rgba(17,16,19,0.75) 100%)'
          }} data-id="element-252" />
          </span>
        </div>

        <div className="relative z-10 mx-auto flex min-h-screen max-w-[1400px] flex-col justify-between px-5 md:px-10 pt-28 md:pt-40 pb-14 md:pb-20" data-id="element-253">
          <div className="max-w-3xl" data-id="element-254">
            <Kicker ig="Kedu Onye Anyị Bụ" en="Who we are" data-id="element-255" />
            <p className="font-display uppercase mt-6 text-2xl md:text-4xl leading-[1.15] tracking-tight" data-id="element-256">
              <Reveal data-id="element-257">We shape the brand.</Reveal>
              <Reveal delay={120} data-id="element-258">
                Then we build <span className="text-outline" data-id="element-259">the world</span>{' '}
                around it.
              </Reveal>
            </p>
          </div>

          <div data-id="element-260">
            <h1 className="font-display uppercase tracking-tight leading-[0.9] text-[15vw] md:text-[10.5vw]" data-id="element-261">
              <span className="block" data-id="element-262">
                <CharReveal text="We are" step={30} data-id="element-263" />
              </span>
              <span className="block" style={{
              color: 'var(--danfo)'
            }} data-id="element-264">
                <CharReveal text="Nkali" baseDelay={220} step={34} data-id="element-265" />
                <CharReveal text="®" baseDelay={520} data-id="element-266" />
              </span>
            </h1>

            <div className="mt-8 grid gap-8 md:grid-cols-2 md:items-end" data-id="element-267">
              <p className="font-monoui text-[11px] md:text-xs uppercase tracking-[0.2em] leading-loose opacity-70" data-id="element-268">
                14 Adeola Odeku Street
                <br data-id="element-269" />
                Victoria Island, Lagos
                <br data-id="element-270" />
                Nigeria
              </p>
              <p className="text-lg md:text-2xl leading-snug md:justify-self-end md:text-right" data-id="element-271">
                Nkali is an independent brand, web and motion studio based in
                Lagos, working with companies worldwide.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Statement / ethos */}
      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-36" data-id="element-272">
        <Kicker ig="Ihe Kpatara Anyị" en="Why we exist" data-id="element-273" />
        <div className="mt-8 md:mt-12 font-display uppercase leading-[1.05] text-3xl md:text-6xl max-w-5xl" data-id="element-274">
          <Reveal data-id="element-275">We started Nkali</Reveal>
          <Reveal delay={120} data-id="element-276">
            because good work{' '}
            <span style={{
            color: 'var(--danfo)'
          }} data-id="element-277">
              gets buried
            </span>
          </Reveal>
          <Reveal delay={240} data-id="element-278">
            under <span className="text-outline" data-id="element-279">forgettable</span> brands.
          </Reveal>
        </div>
        <div className="mt-10 md:mt-14 grid gap-8 md:grid-cols-2 max-w-4xl" data-id="element-280">
          <p className="text-base md:text-lg leading-relaxed" style={{
          color: 'var(--paper-dim)'
        }} data-id="element-281">
            Nkali is an Igbo word: to be greater than. It is the standard we
            hold every project to. Not louder, not busier, but sharper and
            impossible to ignore.
          </p>
          <p className="text-base md:text-lg leading-relaxed" style={{
          color: 'var(--paper-dim)'
        }} data-id="element-282">
            We are a small, senior team by design. No handoffs to juniors, no
            layers between you and the people making the work. The result is
            fewer, better decisions and a studio that argues for the right
            thing.
          </p>
        </div>
      </section>

      {/* Numbers */}
      <section className="mx-auto max-w-[1400px] px-5 md:px-10 pb-24 md:pb-32" data-id="element-283">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12" data-id="element-284">
          {STATS.map(s => <div key={s.label} className="border-t pt-6" style={{
          borderColor: 'var(--line)'
        }} data-id="element-285">
              <p className="font-display text-5xl md:text-7xl" data-id="element-286">
                <Odometer value={s.value} data-id="element-287" />
                {s.suffix && <span style={{
              color: 'var(--danfo)'
            }} data-id="element-288">
                    {s.suffix}
                  </span>}
              </p>
              <p className="font-monoui text-[11px] md:text-xs uppercase tracking-[0.18em] mt-3 opacity-50" data-id="element-289">
                {s.label}
              </p>
            </div>)}
        </div>
      </section>

      {/* Principles */}
      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32 border-t" style={{
      borderColor: 'var(--line)'
    }} data-id="element-290">
        <Kicker ig="Ụkpụrụ Anyị" en="How we think" data-id="element-291" />
        <h2 className="font-display uppercase text-5xl md:text-8xl tracking-tight mt-4" data-id="element-292">
          <CharReveal text="Principles" data-id="element-293" />
        </h2>
        <div className="mt-12 md:mt-16 grid gap-10 md:grid-cols-2 md:gap-x-14 md:gap-y-16" data-id="element-294">
          {PRINCIPLES.map((p, i) => <FadeUp key={p.n} delay={i * 110} data-id="element-295">
              <div className="flex gap-6 md:gap-8" data-id="element-296">
                <span className="font-display text-outline text-3xl md:text-5xl shrink-0" data-id="element-297">
                  {p.n}
                </span>
                <div data-id="element-298">
                  <h3 className="font-display uppercase text-2xl md:text-4xl tracking-tight" data-id="element-299">
                    {p.title}
                  </h3>
                  <p className="mt-3 md:mt-4 text-base md:text-lg leading-relaxed" style={{
                color: 'var(--paper-dim)'
              }} data-id="element-300">
                    {p.desc}
                  </p>
                </div>
              </div>
            </FadeUp>)}
        </div>
      </section>

      {/* Team */}
      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32 border-t" style={{
      borderColor: 'var(--line)'
    }} data-id="element-301">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-302">
          <div data-id="element-303">
            <Kicker ig="Ndị Otu" en="The team" data-id="element-304" />
            <h2 className="font-display uppercase text-5xl md:text-8xl tracking-tight mt-4" data-id="element-305">
              <CharReveal text="Faces" data-id="element-306" />
            </h2>
          </div>
          <p className="max-w-sm text-sm md:text-base leading-relaxed" style={{
          color: 'var(--paper-dim)'
        }} data-id="element-307">
            Senior hands on every project, plus a trusted bench of specialists
            we bring in when the work calls for it.
          </p>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6" data-id="element-308">
          {TEAM.map((m, i) => <FadeUp key={m.name} delay={i * 90} data-id="element-309">
              <figure className="group" data-id="element-310">
                <div className="relative aspect-[4/5] overflow-hidden rounded-2xl border" style={{
              background: 'var(--ink-2)',
              borderColor: 'var(--line)'
            }} data-id="element-311">
                  <img src={m.img} alt={m.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" style={{
                filter: 'saturate(0.6)'
              }} data-id="element-312" />
                  <span aria-hidden="true" className="absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{
                background: 'var(--danfo)',
                mixBlendMode: 'multiply'
              }} data-id="element-313" />
                </div>
                <figcaption className="mt-4" data-id="element-314">
                  <p className="font-display uppercase text-lg md:text-xl tracking-tight" data-id="element-315">
                    {m.name}
                  </p>
                  <p className="font-monoui text-[11px] uppercase tracking-[0.18em] opacity-50 mt-1.5" data-id="element-316">
                    {m.role}
                  </p>
                </figcaption>
              </figure>
            </FadeUp>)}
        </div>
      </section>

      {/* CTA back to work / contact */}
      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32 border-t" style={{
      borderColor: 'var(--line)'
    }} data-id="element-317">
        <div className="flex flex-col items-start gap-8 md:flex-row md:items-center md:justify-between" data-id="element-318">
          <h2 className="font-display uppercase text-4xl md:text-7xl tracking-tight leading-[0.95] max-w-3xl" data-id="element-319">
            <CharReveal text="See the work" step={30} data-id="element-320" />
          </h2>
          <div className="flex flex-wrap items-center gap-4" data-id="element-321">
            <Link to="/#work" className="font-monoui text-xs uppercase tracking-[0.18em] px-7 py-4 transition-transform hover:-translate-y-0.5" style={{
            background: 'var(--danfo)',
            color: 'var(--ink)'
          }} data-id="element-322">
              View projects
            </Link>
            <Link to="/#contact" className="font-monoui text-xs uppercase tracking-[0.18em] px-7 py-4 border transition-transform hover:-translate-y-0.5" style={{
            borderColor: 'var(--line)'
          }} data-id="element-323">
              Start a project
            </Link>
          </div>
        </div>
      </section>

      <Footer data-id="element-324" />
    </main>;
}